export default __webpack_public_path__ + "static/sampleCodeCatalog-6bb9dcb6027e24058a0c70a10ce6c515.png";